import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CreatableSelect from 'react-select/creatable';
import DropdownIndicator from '../DropdownIndicator';
import './MultiSelectCreatableTextInput.scss';
var components = function components(showDropdownIndicator) {
  return {
    DropdownIndicator: showDropdownIndicator ? DropdownIndicator : function () {
      return null;
    },
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    }
  };
};
var createOption = function createOption(label) {
  return {
    label: label,
    value: "custom:".concat(label)
  };
};
var MultiSelectCreatableTextInput = /*#__PURE__*/function (_Component) {
  function MultiSelectCreatableTextInput(props) {
    var _this;
    _classCallCheck(this, MultiSelectCreatableTextInput);
    _this = _callSuper(this, MultiSelectCreatableTextInput, [props]);
    _this.state = {
      inputValue: ''
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(MultiSelectCreatableTextInput, _Component);
  return _createClass(MultiSelectCreatableTextInput, [{
    key: "handleChange",
    value: function handleChange(values, actionMeta) {
      var handleCustomSelectChange = this.props.handleCustomSelectChange;
      handleCustomSelectChange(values, actionMeta.action);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value) {
      this.setState({
        inputValue: value
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var handleCustomSelectChange = this.props.handleCustomSelectChange;
      var inputValue = this.state.inputValue;
      if (event.key === 'Backspace' && !inputValue) {
        handleCustomSelectChange(this.props.values, 'delete-value-key');
        event.preventDefault();
        return;
      }
      if (!inputValue) return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          handleCustomSelectChange(createOption(inputValue));
          this.setState({
            inputValue: ''
          });
          event.preventDefault();
          break;
        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        values = _this$props.values,
        isDisabled = _this$props.isDisabled,
        enterPrompt = _this$props.enterPrompt,
        showDropdownIndicator = _this$props.showDropdownIndicator;
      var inputValue = this.state.inputValue;
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/React.createElement(CreatableSelect, {
        components: components(showDropdownIndicator),
        inputValue: inputValue,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        placeholder: enterPrompt ? 'Type here and press Enter after each item' : 'Enter...',
        onInputChange: this.handleInputChange,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        value: values,
        isDisabled: isDisabled,
        classNamePrefix: "body-text-2 clora-multiselect clora-multiselect-custom"
      }), enterPrompt && /*#__PURE__*/React.createElement("div", {
        className: "mt-3 body-text-3 orange-warning-text"
      }, /*#__PURE__*/React.createElement("i", {
        className: "me-2 fa fa-exclamation-triangle"
      }), /*#__PURE__*/React.createElement("strong", null, "Press Enter"), ' ', "after typing each item."));
    }
  }]);
}(Component);
MultiSelectCreatableTextInput.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({})),
  handleCustomSelectChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  enterPrompt: PropTypes.bool,
  showDropdownIndicator: PropTypes.bool
};
MultiSelectCreatableTextInput.defaultProps = {
  values: [],
  isDisabled: false,
  enterPrompt: false,
  showDropdownIndicator: true
};
export default MultiSelectCreatableTextInput;